<template>
  <v-container class="pa-0">
    <Subheader v-model="search" title="Standards" search="Standards">
      <v-btn small color="add" @click="clickAddStandard()">
        <v-icon class="mr-1">add</v-icon>{{ $t('Button.Add') }}
      </v-btn>
    </Subheader>
    <v-card>
      <v-data-table :headers="headers" :items="originalData.Standards" hide-actions :search="search">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left" width="15%">{{ props.item.AnalyteNameInGuideline }}</td>
          <td class="text-xs-left" width="15%" v-html="getGuidelineValue(props.item)"></td>
          <td class="text-xs-left" width="7%">{{ props.item.ValueType }}</td>
          <td class="text-xs-left" width="7%">{{ props.item.Unit }}</td>
          <td class="text-xs-left" width="7%">{{ props.item.ComparisonOperation }}</td>
          <template v-if="IsHtml(props.item.ReferenceSource)">
            <td class="text-xs-left" v-if="linkTo(props.item.ReferenceSource)">
              <a :href="linkTo(props.item.ReferenceSource)" target="_blank">{{ props.item.ReferenceSource }}</a>
            </td>
            <td class="text-xs-left" v-else v-html="props.item.ReferenceSource"></td>
          </template>
          <template v-if="!IsHtml(props.item.ReferenceSource)">
            <td class="text-xs-left" v-html="linkExtract(props.item.ReferenceSource)"></td>
          </template>
          <td class="text-xs-left">{{ props.item.LastModifiedDateTime != null ? formatDate(props.item.LastModifiedDateTime, prettyDateTimeFormat) : '' }}</td>
          <td class="text-xs-left">{{ props.item.Notes }}</td>
          <td class="text-xs-left">{{ props.item.LastModifiedBy }}</td>
          <td class="text-xs-right" width="18%">
            <v-btn small dark color="warning" @click="clickEditStandard(props.item)">
              <v-icon class="mr-1">edit</v-icon>
              {{ $t('Button.Edit') }}
            </v-btn>
            <v-btn small dark color="delete" @click="clickDeleteStandard(props.item)">
              <v-icon class="mr-1">delete_forever</v-icon>
              {{ $t('Button.Remove') }}
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('GuidelinesDetailStandards.titleMsg',{ msg: titleInfo }) }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout row wrap pl-5 pr-5>
              <v-flex xs12>
                <v-text-field label="Analyte Name" v-model="standardData.AnalyteNameInGuideline" :rules="AnalyteNameRule"></v-text-field>
                <HighlightTextField v-if="standardData.ValueType!=AmmoniaLookupTable && standardData.ValueType!=LookupTable" :label="'Guideline Value'" v-model="standardData.StandardValue" :rules="valueRule" :dialog="dialog" :useMenu="true" @formulaList="getFormulaList"></HighlightTextField>
                <div v-else>
                  <div><span class="caption">Guideline Value</span></div>
                  <div>
                    <v-alert :value="true" type="warning">
                     <span>Editing Lookup table guideline type is not supported yet. Please contact the system administrator is changed to the lookup table guideline is needed.</span>
                    </v-alert>
                  </div>
                </div>
              </v-flex>
              <v-flex xs4 pr-3>
                <v-autocomplete label="Unit" v-model="standardData.Unit" :items="allUnits" item-text="Name" item-value="Name" :rules="unitRule"></v-autocomplete>
              </v-flex>
              <v-flex xs4 pl-2 pr-2>
                <v-text-field v-if="standardData.ValueType==AmmoniaLookupTable" label="ValueType" :value="AmmoniaLookupTable" disabled></v-text-field>
                <v-text-field v-else-if="standardData.ValueType==LookupTable" label="ValueType" :value="LookupTable" disabled></v-text-field>
                <v-autocomplete v-else label="ValueType" v-model="standardData.ValueType" :items="valueTypelist" :rules="valueTypeRule"></v-autocomplete>
                
              </v-flex>
              <v-flex xs4 pl-3>
                <v-autocomplete label="Comparison Operation" v-model="standardData.ComparisonOperation" :items="comparisonOperationlist" :rules="comparisonOperationRule"></v-autocomplete>
              </v-flex>
              <!-- <v-flex xs12>
                <v-autocomplete label="Cofactor values rounding" v-model="standardData.InputRounding" :items="numberRoundingOptionsList" :rules="numberRoundingRule"></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete label="Result values rounding" v-model="standardData.OutputRounding" :items="numberRoundingOptionsList" :rules="numberRoundingRule"></v-autocomplete>
              </v-flex> -->
              <v-flex xs12>
                <v-textarea v-model="standardData.ReferenceSource" auto-grow label="Reference Source" rows="1" :rules="referenceRule"></v-textarea>
                <!-- <p style="font-size: 18px">Reference Source input format like: "<b>description[text](url)[text](url)...</b>"</p> -->
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="standardData.Notes" auto-grow label="Notes" rows="1"></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="standardData.LastModifiedBy" auto-grow label="Last Modified By" rows="1"></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <TestFormula :Formula="standardData.StandardValue" :dialog="dialog" :ValueType="standardData.ValueType" />
            <v-spacer></v-spacer>
            <v-btn color="success" @click="checkData()">
              <v-icon>done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn outline color="secondary" @click="closeDialog()">{{ $t('Button.Cancel') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="comfirmDialog" max-width="800">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('GuidelinesDetailStandards.confirmTitleMsg', { msg1: deleteStandard.AnalyteNameInGuideline , msg2: name }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="comfirmDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>{{ $t('GuidelinesDetailStandards.confirmTextMsg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="deleteGuidelineStandard()">
            <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.Remove') }}
          </v-btn>
          <v-btn outline color="secondary" @click.native="comfirmDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-modal v-model="saveComfirmDialog" persistent max-width="600">
      <template v-slot:title>
        {{ $t('GuidelinesDetailStandards.standardValueSaveConfirmTitleMsg', { name:noUnitCofactorString }) }}
      </template>
      <template v-slot:text>
        {{ $t('GuidelinesDetailStandards.standardValueSaveConfirmTextMsg', { name:noUnitCofactorString }) }}
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.native="saveComfirmDialog = false;saveGuidelineStandard()">
          <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn outline color="secondary" @click.native="saveComfirmDialog = false">{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <AppConfirmationModal v-model="differentUnitGroupModel" persistent max-width="800">
      <template v-slot:title>
        {{ $t('GuidelinesDetailStandards.differentTitle', {link: pluralize('link', differentTenants.length)}) }}
      </template>
      <template v-slot:text>
        <v-alert v-model="differentUnitGroupModel" type="warning" outline>
          {{ $t('GuidelinesDetailStandards.differentMsg', {msg: differentTenantsName, tenant: pluralize('tenant', differentTenants.length)}) }}
        </v-alert>
      </template>
      <template v-slot:actions>
        <v-spacer />
        <v-btn color="success" @click="saveGuidelineStandard" dark>
          <v-icon class="mr-1">done</v-icon>{{ $t('Button.Update_Anyway') }}
        </v-btn>
        <v-btn @click="differentUnitGroupModel=false;dialog=false">{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </AppConfirmationModal>

    <v-card>
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar" auto-height>
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import Subheader from '@/components/generic/Subheader'
  import AppModal from '@/components/generic/AppModal'
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import HighlightTextField from '@/components/generic/HighlightTextField'
  import TestFormula from '@/components/generic/TestFormula'
  import { checkUnitNamesEqual } from '@/store/unit'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import { AddGuidelineActionName, AmmoniaLookupTable, LookupTable } from '@/components/mixins/GuidelinesManageUtil'

  import {
    valueTypeCheck,
  } from '@/helpers/valueType'
  import {
    isSubset,
  } from '@/helpers/arrays'
  import {
    pluralize,
  } from '@/helpers/strings'

  import { prettyDateTimeFormat, formatDate } from '@/components/mixins/MomentUtil'
  const guidelines = createNamespacedHelpers('guidelines')
  const guidelinesparameter = createNamespacedHelpers('guidelinesparameter')
  const unit = createNamespacedHelpers('unit')

  export default {
    components: {
      Subheader,
      HighlightTextField,
      TestFormula,
      'app-modal': AppModal,
      AppConfirmationModal,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      currentGuideline: {
        type: Object,
        default: () => {},
      },
      isAddpageForm: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        prettyDateTimeFormat,
        search: '',
        onlyOneParameter: false,
        noParameter: false,
        moreThanOneParameter: false,
        moreThanOneUnit: false,
        parameterListString: '',
        unitListString: '',
        isAddStandard: false,
        dialog: false,
        comfirmDialog: false,
        saveComfirmDialog: false,
        noUnitCofactorList: [],
        differentUnitGroupModel: false,
        differentTenantsName: '',
        differentTenants: [],
        titleInfo: '',
        valid: true,
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        standardData: {},
        originalData: {},
        deleteStandard: '',
        AnalyteNameRule: [
          (v) => !!v || 'Analyte Name is required',
        ],
        valueRule: [
          (v) => {
            if (v) {
              let disableEquation = v.includes('PH_Field') || v.includes('Temperature_Field')
              if (disableEquation) {
                return '[PH_Field] and [Temperature_Field] are reserved cofator names for Ammonia lookup table guidelines.'
              } else {
                return true
              }
            } else {
              return 'Guideline value is required'
            }
          },
        ],
        unitRule: [
          (v) => !!v || 'unit is required',
        ],
        valueTypeRule: [
          (v) => !!v || 'value type is required',
        ],
        comparisonOperationRule: [
          (v) => !!v || 'comparison operation is required',
        ],
        numberRoundingRule: [
          (v) => !!v || 'number rounding option is required',
        ],
        referenceRule: [
          (v) => !!v || 'reference source is required',
        ],
        headers: [{
          text: 'Analyte',
          align: 'left',
          value: 'AnalyteNameInGuideline',
        },
        {
          text: 'Guideline',
          align: 'left',
          value: 'StandardValue',
        },
        {
          text: 'Type',
          align: 'left',
          value: 'ValueType',
        },
        {
          text: 'Unit',
          align: 'left',
          value: 'Unit',
        },
        {
          text: 'Comparison',
          align: 'left',
          value: 'ComparisonOperation',
        },
        {
          text: 'Reference',
          align: 'left',
          value: 'ReferenceSource',
        },
        {
          text: 'Last Modified Date',
          value: 'LastModifiedDateTime',
          align: 'left',
        },
        {
          text: 'Notes',
          value: 'Notes',
          align: 'left',
        },
        {
          text: 'Last Modified By',
          value: 'LastModifiedBy',
          align: 'left',
        },
        {
          text: 'Action',
          value: '',
          align: 'center',
          width: '260',
        },
        ],
      }
    },
    mounted() {
      this.setGuidelineData()
      if (!this.allUnits || !this.allUnits.length) {
        if (!this.isLoadAllUnits) {
          this.changeLoadAllUnits()
          this.getUnitList().then(() => this.changeLoadAllUnits()).catch(() => this.changeLoadAllUnits())
        }
      }
    },
    computed: {
      ...guidelines.mapGetters(['Guidelines', 'analyteInGuidelineList', 'StandardRelevantAnalytes']),
      ...guidelinesparameter.mapGetters(['valueTypelist']),
      ...unit.mapGetters(['allUnits', 'isLoadAllUnitGroups']),
      noUnitCofactorString() {
        if (this.noUnitCofactorList.length > 0) {
          return this.noUnitCofactorList.join(',')
        } else {
          return ''
        }
      },
      comparisonOperationlist() {
        let valueType = this.standardData.ValueType
        if (!valueType) {
          return ['Less', 'LessOrEqual', 'Equal', 'LargerOrEqual', 'Larger', 'Between', 'NotBetween']
        } else if (valueType == 'range') {
          return ['Between', 'NotBetween']
        } else {
          return ['Less', 'LessOrEqual', 'Equal', 'LargerOrEqual', 'Larger']
        }
      },
      AmmoniaLookupTable() {
        return AmmoniaLookupTable
      },
      LookupTable() {
        return LookupTable
      },
      numberRoundingOptionsList() {
        return ['None', 'BCWQG_AL rounding']
      },
    },
    watch: {
      currentGuideline() {
        this.setGuidelineData()
      },
    },
    methods: {
      ...guidelines.mapActions(['postAddGuidelineStandard', 'postUpdateGuidelineStandard', 'postDeleteGuidelineStandard', 'GetStandardRelevantAnalytes']),
      ...unit.mapActions(['getUnitList', 'changeLoadAllUnits']),
      pluralize,
      formatDate,
      startSnack(snackColor, snackMessage) {
        this.snackMessage = snackMessage
        this.snackColor = snackColor
        this.snackbar = true
      },
      setGuidelineData() {
        if (this.name != AddGuidelineActionName && !this.isAddpageForm) {
          this.originalData = JSON.parse(JSON.stringify(this.currentGuideline))
        }
      },
      getGuidelineValue(guideline) {
        if(guideline.ValueType == LookupTable) {
          return '<b class="warning">Viewing lookup table guideline value is not supported yet.</b>'
        }
        return guideline.ValueType == AmmoniaLookupTable ? JSON.parse(guideline.StandardValue).Description :
          guideline.StandardValue.replace('-99999', 'None')
      },
      getAmmoniaLink(guideline) {
        let url = JSON.parse(guideline.StandardValue).Description
        url = url.replace(/Lookup table/g,'Ammonia lookup table')
        return url
      },
      IsHtml(referenceString) {
        if (!referenceString) {
          return true
        } else {
          return referenceString.match('</a>') != null
        }
      },
      linkTo(referenceString) {
        if (referenceString === null) {
          return false
        }
        let result = referenceString.split(' ')
        let loop
        let link = ''
        for (loop = 0; loop < result.length; loop++) {
          if (result[loop].startsWith('http')) {
            link = result[loop]
            return link
          }
        }
        return false
      },
      linkExtract(referenceString) {
        let reg = /\[.*?\]\(.+?\)/g
        let matched = referenceString.match(reg)
        if (matched == null) {
          return '<span>' + referenceString + '</span>'
        } else {
          let nameStr = ''
          let htmlStr = ''
          let index = referenceString.indexOf(matched[0])
          if (index > 0) {
            nameStr = referenceString.substr(0, index)
          }
          matched.forEach(element => {
            let text = element.match(/\[(.+)\]/)
            let url = element.match(/\((.+?)\)/)
            if (url) {
              url = url[1]
            }
            if (text) {
              text = text[1]
            } else {
              text = URLSearchParams
            }
            htmlStr = htmlStr.concat('<a target="_blank" style="color: blue" href="' + url + '">' + text + '</a>')
          })
          htmlStr = '<span>' + nameStr + '</span>' + htmlStr
          return htmlStr
        }
      },
      clickAddStandard() {
        this.$refs.form.reset()
        this.titleInfo = 'Add standard'
        this.isAddStandard = true
        this.dialog = true
      },
      clickEditStandard(standard) {
        this.standardData = JSON.parse(JSON.stringify(standard))
        this.titleInfo = 'Edit ' + standard.AnalyteNameInGuideline + ' Standard'
        this.differentTenantsName = ''
        try {
          this.GetStandardRelevantAnalytes(standard.Id)
          this.dialog = true
        } catch (error) {
          this.dialog = true
        }
      },
      clickDeleteStandard(standard) {
        this.deleteStandard = standard
        this.comfirmDialog = true
      },
      closeDialog() {
        this.dialog = false
        this.isAddStandard = false
        this.standardData = {}
        //this.$refs.form.resetValidation()
      },
      getFormulaList(list) {
        let parameters = []
        if (list && list.length) {
          list.forEach(x => {
            if (x.type == 'parameter') {
              parameters.push(x.value)
            }
          })
          parameters = [...new Set(parameters)]
          this.onlyOneParameter = parameters.length == 1
          if (parameters.length == 0) {
            this.noParameter = true
          } else if (!this.onlyOneParameter) {
            this.noParameter = false
            this.checkParameterAndUnit(parameters)
          } else {
            this.noParameter = false
            this.moreThanOneParameter = false
            this.moreThanOneUnit = false
            this.parameterListString = ''
            this.unitListString = ''
          }
        }
      },
      checkParameterAndUnit(parameters) {
        let parameterList = []
        let unitList = []
        parameters.forEach(x => {
          let arr = x.replace(/^(\s|\[)+|(\s|])+$/g, '').split('|')
          parameterList.push(arr[0])
          unitList.push(arr[1])
        })
        parameterList = [...new Set(parameterList)]
        unitList = [...new Set(unitList)]
        this.parameterListString = parameterList.toString()
        this.unitListString = unitList.toString()
        this.moreThanOneParameter = parameterList.length != 1
        this.moreThanOneUnit = unitList.length != 1
      },
      checkData() {
        if (this.$refs.form.validate()) {
          if (!valueTypeCheck(this.standardData.StandardValue, this.standardData.ValueType)) {
            this.startSnack('error', this.$t('GuidelinesDetailStandards.standardValueErrorFormattingMsg'))
            return
          }

          this.noUnitCofactorList = this.checkEquation(this.standardData.StandardValue)
          if (this.noUnitCofactorList.length > 0) {
            this.saveComfirmDialog = true
          } else {
            if (this.isAddStandard) {
              this.saveGuidelineStandard()
            } else {
              this.checkUnit()
            }
          }
        } else {
          this.startSnack('error', this.$t('GuidelinesDetailStandards.saveFailMsg'))
        }
      },
      checkUnit() {
        if (!this.StandardRelevantAnalytes.length) {
          this.saveGuidelineStandard()
        } else {
          let Names = []
          let targetUnit = this.allUnits.find(x => checkUnitNamesEqual(x.Name, this.standardData.Unit))
          let targetUnitGroup = targetUnit.Groups.map(x => x.Name)
          this.StandardRelevantAnalytes.forEach(x => {
            let unitgroups = x.RelevantAnalytes.map(x => x.UnitGroup)
            if(!isSubset(unitgroups, targetUnitGroup)) {
              Names.push(x.TenantName)
            }
          })
          if(Names.length) {
            this.differentTenants = Names
            this.differentTenantsName = Names.join(', ')
            this.differentUnitGroupModel = true
          } else {
            this.saveGuidelineStandard()
          }
        }
      },
      saveGuidelineStandard() {
        let range = this.standardData.ValueType == 'range'
        let betweenOrNotBetween = this.standardData.ComparisonOperation == 'Between' || this.standardData.ComparisonOperation == 'NotBetween'
        if (range == betweenOrNotBetween) {
          if (range && this.noParameter) {
            this.startSnack('error', 'No variables name found in range guideline standard. Range guideline standards must have a single variable name.')
          } else if (range && this.moreThanOneParameter) {
            this.startSnack('error', `Multiple variables names found in range guideline standard(${this.parameterListString}). Range guideline standards can only use a single variable name.`)
          } else if (range && this.moreThanOneUnit) {
            this.startSnack('error', `Multiple units found in range guideline standard(${this.unitListString}). Range guideline standards can only use a single unit.`)
          } else {
            let matched = this.analyteInGuidelineList.find(x => x == this.standardData.AnalyteNameInGuideline)
            if (matched) {
              this.standardData.WaterQualityLabAnalyteId = matched.WaterQualityLabAnalyteId
              this.standardData.AnalyteNameInGuideline = matched.AnalyteNameInGuideline
            }
            let options = {
              data: {
                Id: this.standardData.Id,
                AnalyteNameInGuideline: this.standardData.AnalyteNameInGuideline,
                Unit: this.standardData.Unit,
                ReferenceSource: this.standardData.ReferenceSource,
                GuidelineId: this.currentGuideline.Id,
                ComparisonOperation: this.standardData.ComparisonOperation,
                StandardValue: this.standardData.StandardValue.trim(),
                ValueType: this.standardData.ValueType,
                Notes: this.standardData.Notes,
                LastModifiedBy: this.standardData.LastModifiedBy,
              },
              successCb: () => {
                this.startSnack('success', this.$t('GuidelinesDetailStandards.updateSuccessMsg', {
                  msg1: this.standardData.AnalyteNameInGuideline,
                  msg2: this.currentGuideline.GuidelineName,
                }))
                this.closeDialog()
                this.differentUnitGroupModel = false
              },
              failedCb: (err) => {
                this.startSnack('error', err)
                this.closeDialog()
                this.differentUnitGroupModel = false
              },
            }
            if (this.standardData.Id == null) {
              this.postAddGuidelineStandard(options)
            } else {
              this.postUpdateGuidelineStandard(options)
            }
          }
        } else {
          this.startSnack('error', 'ValueType and ComparisonOperation could not be null, please check carefully.')
        }
      },
      deleteGuidelineStandard() {
        let options = {
          data: this.deleteStandard,
          successCb: () => {
            this.startSnack('success', this.$t('GuidelinesDetailStandards.deleteSuccessMsg', {
              msg1: this.standardData.AnalyteNameInGuideline,
              msg2: this.currentGuideline.GuidelineName,
            }))
            this.comfirmDialog = false
          },
          failedCb: (err) => {
            this.startSnack('error', err)
          },
        }
        this.postDeleteGuidelineStandard(options)
      },
      checkEquation(expressionString) {
        if (!expressionString) return false
        let regex = /\[(.*?)\]/g
        let params = expressionString.match(regex)
        if (!params || !params.length) return false
        let arr = params.map(x => x.slice(1, x.length - 1))
        if (arr == null) {
          return false
        } else {
          return this.checkCofactorUnit(arr)
        }
      },
      checkCofactorUnit(arr) {
        let errorCofactors = []
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].indexOf('|') > -1) {
            let keyValue = arr[i].split('|')
            if (keyValue.length == 2) {
              continue
            } else {
              errorCofactors.push(keyValue[0])
            }
          } else {
            errorCofactors.push(arr[i])
          }
        }
        let set = new Set(errorCofactors)
        return [...set]
      },
    },
  }
</script>

<style scoped>
  .backgroundColor {
    background-color: #fafafa;
  }

  .removePadding {
    padding: 0px;
  }

  .centerBtn {
    margin: 0 auto;
    display: block;
    width: 40%;
  }
</style>